import { AlertService } from '../../shared/services/alert.service';
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AssessmentService } from "../../shared/services/assessment.service";
import { QuestionSet } from "../../shared/models/question-set";
var QuestionSetNewComponent = /** @class */ (function () {
    function QuestionSetNewComponent(_assessmentService, route, router, alertService) {
        this._assessmentService = _assessmentService;
        this.route = route;
        this.router = router;
        this.alertService = alertService;
        this.questionSet = new QuestionSet();
        this.questionSet.title = "Untitled";
        this.questionSet.id = this._assessmentService.newId();
    }
    QuestionSetNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var assessmentUid = params['uid'];
            var setId = params['setId'];
            _this._assessmentService.getAssessment(assessmentUid)
                .then(function (assessment) {
                _this.assessment = assessment;
            });
        });
    };
    Object.defineProperty(QuestionSetNewComponent.prototype, "questionSet", {
        get: function () {
            return this._questionSet;
        },
        set: function (v) {
            this._questionSet = v;
        },
        enumerable: true,
        configurable: true
    });
    QuestionSetNewComponent.prototype.save = function () {
        var _this = this;
        this.assessment.addQuestionSet(this._questionSet);
        this._assessmentService.saveAssessment(this.assessment).then(function (assessment) {
            _this.alertService.success("Question Set Saved!");
            setTimeout(function () {
                _this.router.navigate(["../", _this._questionSet.id, "edit"], { relativeTo: _this.route, replaceUrl: true });
            }, 1500);
        }).catch(function (error) {
            _this.alertService.error("Error occurred in saving. Please try again");
            console.error(error);
        });
    };
    return QuestionSetNewComponent;
}());
export { QuestionSetNewComponent };



// WEBPACK FOOTER //
// ./src/app/admin/question-set-new/question-set-new.component.ts.pre-build-optimizer.js